import React from "react";
import { Card, Row, Col, Typography, Spin } from "antd";
import { Users, MapPin, Building2, Briefcase } from "lucide-react";
import { CorporationStatsEntity } from "../../../../../serviceoperation/entity/CorporationOperationEntity";

const { Text } = Typography;

export interface OrganizationStats {
  totalEmployees: number;
  totalLocations: number;
  totalDepartments: number;
  activeProjects: number;
}
interface StatisticsGridProps {
  stats?: CorporationStatsEntity;
  loading: boolean;
}

const StatisticsGrid: React.FC<StatisticsGridProps> = ({ stats, loading }) => {
  const statItems = [
    {
      icon: Users,
      label: "Total Employees",
      value: stats?.totalEmployees ?? 0,
      color: "#1890ff",
      bgColor: "#e6f7ff",
    },
    {
      icon: MapPin,
      label: "Locations",
      value: stats?.totalBranches ?? 0,
      color: "#52c41a",
      bgColor: "#f6ffed",
    },
    {
      icon: Building2,
      label: "Departments",
      value: stats?.totalDepartments ?? 0,
      color: "#722ed1",
      bgColor: "#f9f0ff",
    },
    {
      icon: Briefcase,
      label: "Active Projects",
      value: 0,
      color: "#fa8c16",
      bgColor: "#fff7e6",
    },
  ];

  return (
    <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
      {statItems.map(({ icon: Icon, label, value, color, bgColor }) => (
        <Col key={label} xs={24} sm={12} lg={6}>
          <Card hoverable>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div
                style={{
                  padding: 12,
                  borderRadius: 8,
                  backgroundColor: bgColor,
                }}
              >
                <Icon size={24} color={color} />
              </div>
              <div>
                <Text type="secondary">{label}</Text>
                <div
                  style={{
                    fontSize: 24,
                    fontWeight: 600,
                    lineHeight: 1.2,
                  }}
                >
                  {loading ? <Spin size="small" /> : value}
                </div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default StatisticsGrid;
